import { render, staticRenderFns } from "./CheckoutAddressOptions.vue?vue&type=template&id=60bbf276"
import script from "./CheckoutAddressOptions.vue?vue&type=script&lang=js"
export * from "./CheckoutAddressOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports